import React from 'react';




// import img
import Image from '../assets/img/download-removebg-preview.jpg';

const About = () => {
 
  return (
    <section className='section bg-secondary' id='about'>
      <h1 className='text-center text-5xl  mb-11'>About me</h1>
      <div className='container mx-auto'>
        
        <div className='flex flex-col xl:flex-row gap-24'>
          <img
            className='object-cover h-full w-[566px] md:mx-auto lg:mx-0 rounded-2xl'
            src={Image}
            alt=''
          />
          <div className='flex flex-col items-center text-center lg:items-start lg:text-left'>
            <div className='flex flex-col'>
              
              <h2 className='text-3xl lg:text-4xl font-medium lg:font-extrabold mb-3  relative before:absolute before:opacity-40 before:-top-[2rem] before:hidden before:lg:block'>
                MORSHED ALI
              </h2>
              <p className='mb-4 text-accent'>
               Frontend Web Developer
              </p>
              <hr className='mb-8 opacity-5' />
              <p className='mb-8'>
                As a web developer i always try to learn new technology and up-to-date myself.I have create so many project using react,node and mongoDB <br />
                <br />
                I’ve made and resolved a lot of bugs.Hundreds of them so far.Some were harder, some were easier to solve.
              </p>
            </div>
            
            <a className="btn btn-active btn-secondary border" href='https://drive.google.com/file/d/15ZZJ6PyqFfzDA8kXjpzBKHx6wxtY7VC_/view?usp=sharing' target='_blank'>See Resume</a>
            
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
